export enum GettersTypes {
  
}

export const getters = {
  
}
